const countries = [
  {
    code: "AD",
    label: "Andorra (+376)",
    phone: "376",
  },
  {
    code: "AE",
    label: "United Arab Emirates (+971)",
    phone: "971",
  },
  {
    code: "AF",
    label: "Afghanistan (+93)",
    phone: "93",
  },
  {
    code: "AG",
    label: "Antigua and Barbuda (+1-268)",
    phone: "1-268",
  },
  {
    code: "AI",
    label: "Anguilla (+1-264)",
    phone: "1-264",
  },
  {
    code: "AL",
    label: "Albania (+355)",
    phone: "355",
  },
  {
    code: "AM",
    label: "Armenia (+374)",
    phone: "374",
  },
  {
    code: "AO",
    label: "Angola (+244)",
    phone: "244",
  },
  {
    code: "AQ",
    label: "Antarctica (+672)",
    phone: "672",
  },
  {
    code: "AR",
    label: "Argentina (+54)",
    phone: "54",
  },
  {
    code: "AS",
    label: "American Samoa (1-684)",
    phone: "1-684",
  },
  {
    code: "AT",
    label: "Austria (+43)",
    phone: "43",
  },
  {
    code: "AU",
    label: "Australia (+61)",
    phone: "61",
    suggested: true,
  },
  {
    code: "AW",
    label: "Aruba (+297)",
    phone: "297",
  },
  {
    code: "AX",
    label: "Alland Islands (+358)",
    phone: "358",
  },
  {
    code: "AZ",
    label: "Azerbaijan (+994)",
    phone: "994",
  },
  {
    code: "BA",
    label: "Bosnia and Herzegovina (+387)",
    phone: "387",
  },
  {
    code: "BB",
    label: "Barbados (+1-246)",
    phone: "1-246",
  },
  {
    code: "BD",
    label: "Bangladesh (+880)",
    phone: "880",
  },
  {
    code: "BE",
    label: "Belgium (+32)",
    phone: "32",
  },
  {
    code: "BF",
    label: "Burkina Faso (+226)",
    phone: "226",
  },
  {
    code: "BG",
    label: "Bulgaria (+359)",
    phone: "359",
  },
  {
    code: "BH",
    label: "Bahrain (+973)",
    phone: "973",
  },
  {
    code: "BI",
    label: "Burundi (+257)",
    phone: "257",
  },
  {
    code: "BJ",
    label: "Benin (+229)",
    phone: "229",
  },
  {
    code: "BL",
    label: "Saint Barthelemy (+590)",
    phone: "590",
  },
  {
    code: "BM",
    label: "Bermuda (+1-441)",
    phone: "1-441",
  },
  {
    code: "BN",
    label: "Brunei Darussalam (+673)",
    phone: "673",
  },
  {
    code: "BO",
    label: "Bolivia (+591)",
    phone: "591",
  },
  {
    code: "BR",
    label: "Brazil (+55)",
    phone: "55",
  },
  {
    code: "BS",
    label: "Bahamas (+1-242)",
    phone: "1-242",
  },
  {
    code: "BT",
    label: "Bhutan (+975)",
    phone: "975",
  },
  {
    code: "BV",
    label: "Bouvet Island (+47)",
    phone: "47",
  },
  {
    code: "BW",
    label: "Botswana (+267)",
    phone: "267",
  },
  {
    code: "BY",
    label: "Belarus (+375)",
    phone: "375",
  },
  {
    code: "BZ",
    label: "Belize (+501)",
    phone: "501",
  },
  {
    code: "CA",
    label: "Canada (+1)",
    phone: "1",
    suggested: true,
  },
  {
    code: "CC",
    label: "Cocos (Keeling) Islands (+61)",
    phone: "61",
  },
  {
    code: "CD",
    label: "Congo, Democratic Republic of the (+243)",
    phone: "243",
  },
  {
    code: "CF",
    label: "Central African Republic (+236)",
    phone: "236",
  },
  {
    code: "CG",
    label: "Congo, Republic of the (+242)",
    phone: "242",
  },
  {
    code: "CH",
    label: "Switzerland (+41)",
    phone: "41",
  },
  {
    code: "CI",
    label: "Cote d'Ivoire (+225)",
    phone: "225",
  },
  {
    code: "CK",
    label: "Cook Islands (+682)",
    phone: "682",
  },
  {
    code: "CL",
    label: "Chile (+56)",
    phone: "56",
  },
  {
    code: "CM",
    label: "Cameroon (+237)",
    phone: "237",
  },
  {
    code: "CN",
    label: "China (+86)",
    phone: "86",
  },
  {
    code: "CO",
    label: "Colombia (+57)",
    phone: "57",
  },
  {
    code: "CR",
    label: "Costa Rica (+506)",
    phone: "506",
  },
  {
    code: "CU",
    label: "Cuba (+53)",
    phone: "53",
  },
  {
    code: "CV",
    label: "Cape Verde (+238)",
    phone: "238",
  },
  {
    code: "CW",
    label: "Curacao (+599)",
    phone: "599",
  },
  {
    code: "CX",
    label: "Christmas Island (+61)",
    phone: "61",
  },
  {
    code: "CY",
    label: "Cyprus (+357)",
    phone: "357",
  },
  {
    code: "CZ",
    label: "Czech Republic (+420)",
    phone: "420",
  },
  {
    code: "DE",
    label: "Germany (+49)",
    phone: "49",
    suggested: true,
  },
  {
    code: "DJ",
    label: "Djibouti (+253)",
    phone: "253",
  },
  {
    code: "DK",
    label: "Denmark (+45)",
    phone: "45",
  },
  {
    code: "DM",
    label: "Dominica (+1-767)",
    phone: "1-767",
  },
  {
    code: "DO",
    label: "Dominican Republic (+1-809)",
    phone: "1-809",
  },
  {
    code: "DZ",
    label: "Algeria (+213)",
    phone: "213",
  },
  {
    code: "EC",
    label: "Ecuador (+593)",
    phone: "593",
  },
  {
    code: "EE",
    label: "Estonia (+372)",
    phone: "372",
  },
  {
    code: "EG",
    label: "Egypt (+20)",
    phone: "20",
  },
  {
    code: "EH",
    label: "Western Sahara (+212)",
    phone: "212",
  },
  {
    code: "ER",
    label: "Eritrea (+291)",
    phone: "291",
  },
  {
    code: "ES",
    label: "Spain (+34)",
    phone: "34",
  },
  {
    code: "ET",
    label: "Ethiopia (+251)",
    phone: "251",
  },
  {
    code: "FI",
    label: "Finland (+358)",
    phone: "358",
  },
  {
    code: "FJ",
    label: "Fiji (+679)",
    phone: "679",
  },
  {
    code: "FK",
    label: "Falkland Islands (Malvinas) (+500)",
    phone: "500",
  },
  {
    code: "FM",
    label: "Micronesia, Federated States of (+691)",
    phone: "691",
  },
  {
    code: "FO",
    label: "Faroe Islands (+298)",
    phone: "298",
  },
  {
    code: "FR",
    label: "France (+33)",
    phone: "33",
    suggested: true,
  },
  {
    code: "GA",
    label: "Gabon (+241)",
    phone: "241",
  },
  {
    code: "GB",
    label: "United Kingdom (+44)",
    phone: "44",
  },
  {
    code: "GD",
    label: "Grenada (+1-473)",
    phone: "1-473",
  },
  {
    code: "GE",
    label: "Georgia (+995)",
    phone: "995",
  },
  {
    code: "GF",
    label: "French Guiana (+594)",
    phone: "594",
  },
  {
    code: "GG",
    label: "Guernsey (+44)",
    phone: "44",
  },
  {
    code: "GH",
    label: "Ghana (+233)",
    phone: "233",
  },
  {
    code: "GI",
    label: "Gibraltar (+350)",
    phone: "350",
  },
  {
    code: "GL",
    label: "Greenland (+299)",
    phone: "299",
  },
  {
    code: "GM",
    label: "Gambia (+220)",
    phone: "220",
  },
  {
    code: "GN",
    label: "Guinea (+224)",
    phone: "224",
  },
  {
    code: "GP",
    label: "Guadeloupe (+590)",
    phone: "590",
  },
  {
    code: "GQ",
    label: "Equatorial Guinea (+240)",
    phone: "240",
  },
  {
    code: "GR",
    label: "Greece (+30)",
    phone: "30",
  },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands (+500)",
    phone: "500",
  },
  {
    code: "GT",
    label: "Guatemala (+502)",
    phone: "502",
  },
  {
    code: "GU",
    label: "Guam (+1-671)",
    phone: "1-671",
  },
  {
    code: "GW",
    label: "Guinea-Bissau (+245)",
    phone: "245",
  },
  {
    code: "GY",
    label: "Guyana (+592)",
    phone: "592",
  },
  {
    code: "HK",
    label: "Hong Kong (+852)",
    phone: "852",
  },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands (+672)",
    phone: "672",
  },
  {
    code: "HN",
    label: "Honduras (+504)",
    phone: "504",
  },
  {
    code: "HR",
    label: "Croatia (+385)",
    phone: "385",
  },
  {
    code: "HT",
    label: "Haiti (+509)",
    phone: "509",
  },
  {
    code: "HU",
    label: "Hungary (+36)",
    phone: "36",
  },
  {
    code: "ID",
    label: "Indonesia (+62)",
    phone: "62",
  },
  {
    code: "IE",
    label: "Ireland (+353)",
    phone: "353",
  },
  {
    code: "IL",
    label: "Israel (+972)",
    phone: "972",
  },
  {
    code: "IM",
    label: "Isle of Man (+44)",
    phone: "44",
  },
  {
    code: "IN",
    label: "India (+91)",
    phone: "91",
  },
  {
    code: "IO",
    label: "British Indian Ocean Territory (+246)",
    phone: "246",
  },
  {
    code: "IQ",
    label: "Iraq (+964)",
    phone: "964",
  },
  {
    code: "IR",
    label: "Iran, Islamic Republic of (+98)",
    phone: "98",
  },
  {
    code: "IS",
    label: "Iceland (+354)",
    phone: "354",
  },
  {
    code: "IT",
    label: "Italy (+39)",
    phone: "39",
  },
  {
    code: "JE",
    label: "Jersey (+44)",
    phone: "44",
  },
  {
    code: "JM",
    label: "Jamaica (+1-876)",
    phone: "1-876",
  },
  {
    code: "JO",
    label: "Jordan (+962)",
    phone: "962",
  },
  {
    code: "JP",
    label: "Japan (+81)",
    phone: "81",
    suggested: true,
  },
  {
    code: "KE",
    label: "Kenya (+254)",
    phone: "254",
  },
  {
    code: "KG",
    label: "Kyrgyzstan (+996)",
    phone: "996",
  },
  {
    code: "KH",
    label: "Cambodia (+855)",
    phone: "855",
  },
  {
    code: "KI",
    label: "Kiribati (+686)",
    phone: "686",
  },
  {
    code: "KM",
    label: "Comoros (+269)",
    phone: "269",
  },
  {
    code: "KN",
    label: "Saint Kitts and Nevis (+1-869)",
    phone: "1-869",
  },
  {
    code: "KP",
    label: "Korea, Democratic People's Republic of (+850)",
    phone: "850",
  },
  {
    code: "KR",
    label: "Korea, Republic of (+82)",
    phone: "82",
  },
  {
    code: "KW",
    label: "Kuwait (+965)",
    phone: "965",
  },
  {
    code: "KY",
    label: "Cayman Islands (+1-345)",
    phone: "1-345",
  },
  {
    code: "KZ",
    label: "Kazakhstan (+7)",
    phone: "7",
  },
  {
    code: "LA",
    label: "Lao People's Democratic Republic (+856)",
    phone: "856",
  },
  {
    code: "LB",
    label: "Lebanon (+961)",
    phone: "961",
  },
  {
    code: "LC",
    label: "Saint Lucia (+1-758)",
    phone: "1-758",
  },
  {
    code: "LI",
    label: "Liechtenstein (+423)",
    phone: "423",
  },
  {
    code: "LK",
    label: "Sri Lanka (+94)",
    phone: "94",
  },
  {
    code: "LR",
    label: "Liberia (+231)",
    phone: "231",
  },
  {
    code: "LS",
    label: "Lesotho (+266)",
    phone: "266",
  },
  {
    code: "LT",
    label: "Lithuania (+370)",
    phone: "370",
  },
  {
    code: "LU",
    label: "Luxembourg (+352)",
    phone: "352",
  },
  {
    code: "LV",
    label: "Latvia (+371)",
    phone: "371",
  },
  {
    code: "LY",
    label: "Libya (+218)",
    phone: "218",
  },
  {
    code: "MA",
    label: "Morocco (+212)",
    phone: "212",
  },
  {
    code: "MC",
    label: "Monaco (+377)",
    phone: "377",
  },
  {
    code: "MD",
    label: "Moldova, Republic of (+373)",
    phone: "373",
  },
  {
    code: "ME",
    label: "Montenegro (+382)",
    phone: "382",
  },
  {
    code: "MF",
    label: "Saint Martin (French part) (+590)",
    phone: "590",
  },
  {
    code: "MG",
    label: "Madagascar (+261)",
    phone: "261",
  },
  {
    code: "MH",
    label: "Marshall Islands (+692)",
    phone: "692",
  },
  {
    code: "MK",
    label: "Macedonia, the Former Yugoslav Republic of (+389)",
    phone: "389",
  },
  {
    code: "ML",
    label: "Mali (+223)",
    phone: "223",
  },
  {
    code: "MM",
    label: "Myanmar (+95)",
    phone: "95",
  },
  {
    code: "MN",
    label: "Mongolia (+976)",
    phone: "976",
  },
  {
    code: "MO",
    label: "Macao (+853)",
    phone: "853",
  },
  {
    code: "MP",
    label: "Northern Mariana Islands (+1-670)",
    phone: "1-670",
  },
  {
    code: "MQ",
    label: "Martinique (+596)",
    phone: "596",
  },
  {
    code: "MR",
    label: "Mauritania (+222)",
    phone: "222",
  },
  {
    code: "MS",
    label: "Montserrat (+1-664)",
    phone: "1-664",
  },
  {
    code: "MT",
    label: "Malta (+356)",
    phone: "356",
  },
  {
    code: "MU",
    label: "Mauritius (+230)",
    phone: "230",
  },
  {
    code: "MV",
    label: "Maldives (+960)",
    phone: "960",
  },
  {
    code: "MW",
    label: "Malawi (+265)",
    phone: "265",
  },
  {
    code: "MX",
    label: "Mexico (+52)",
    phone: "52",
  },
  {
    code: "MY",
    label: "Malaysia (+60)",
    phone: "60",
  },
  {
    code: "MZ",
    label: "Mozambique (+258)",
    phone: "258",
  },
  {
    code: "NA",
    label: "Namibia (+264)",
    phone: "264",
  },
  {
    code: "NC",
    label: "New Caledonia (+687)",
    phone: "687",
  },
  {
    code: "NE",
    label: "Niger (+227)",
    phone: "227",
  },
  {
    code: "NF",
    label: "Norfolk Island (+672)",
    phone: "672",
  },
  {
    code: "NG",
    label: "Nigeria (+234)",
    phone: "234",
  },
  {
    code: "NI",
    label: "Nicaragua (+505)",
    phone: "505",
  },
  {
    code: "NL",
    label: "Netherlands (+31)",
    phone: "31",
  },
  {
    code: "NO",
    label: "Norway (+47)",
    phone: "47",
  },
  {
    code: "NP",
    label: "Nepal (+977)",
    phone: "977",
  },
  {
    code: "NR",
    label: "Nauru (+674)",
    phone: "674",
  },
  {
    code: "NU",
    label: "Niue (+683)",
    phone: "683",
  },
  {
    code: "NZ",
    label: "New Zealand (+64)",
    phone: "64",
  },
  {
    code: "OM",
    label: "Oman (+968)",
    phone: "968",
  },
  {
    code: "PA",
    label: "Panama (+507)",
    phone: "507",
  },
  {
    code: "PE",
    label: "Peru (+51)",
    phone: "51",
  },
  {
    code: "PF",
    label: "French Polynesia (+689)",
    phone: "689",
  },
  {
    code: "PG",
    label: "Papua New Guinea (+675)",
    phone: "675",
  },
  {
    code: "PH",
    label: "Philippines (+63)",
    phone: "63",
  },
  {
    code: "PK",
    label: "Pakistan (+92)",
    phone: "92",
  },
  {
    code: "PL",
    label: "Poland (+48)",
    phone: "48",
  },
  {
    code: "PM",
    label: "Saint Pierre and Miquelon (+508)",
    phone: "508",
  },
  {
    code: "PN",
    label: "Pitcairn (+870)",
    phone: "870",
  },
  {
    code: "PR",
    label: "Puerto Rico (+1)",
    phone: "1",
  },
  {
    code: "PS",
    label: "Palestine, State of (+970)",
    phone: "970",
  },
  {
    code: "PT",
    label: "Portugal (+351)",
    phone: "351",
  },
  {
    code: "PW",
    label: "Palau (+680)",
    phone: "680",
  },
  {
    code: "PY",
    label: "Paraguay (+595)",
    phone: "595",
  },
  {
    code: "QA",
    label: "Qatar (+974)",
    phone: "974",
  },
  {
    code: "RE",
    label: "Reunion (+262)",
    phone: "262",
  },
  {
    code: "RO",
    label: "Romania (+40)",
    phone: "40",
  },
  {
    code: "RS",
    label: "Serbia (+381)",
    phone: "381",
  },
  {
    code: "RU",
    label: "Russian Federation (+7)",
    phone: "7",
  },
  {
    code: "RW",
    label: "Rwanda (+250)",
    phone: "250",
  },
  {
    code: "SA",
    label: "Saudi Arabia (+266)",
    phone: "966",
  },
  {
    code: "SB",
    label: "Solomon Islands (+677)",
    phone: "677",
  },
  {
    code: "SC",
    label: "Seychelles (+248)",
    phone: "248",
  },
  {
    code: "SD",
    label: "Sudan (+249)",
    phone: "249",
  },
  {
    code: "SE",
    label: "Sweden (+46)",
    phone: "46",
  },
  {
    code: "SG",
    label: "Singapore (+65)",
    phone: "65",
  },
  {
    code: "SH",
    label: "Saint Helena (+290)",
    phone: "290",
  },
  {
    code: "SI",
    label: "Slovenia (+386)",
    phone: "386",
  },
  {
    code: "SJ",
    label: "Svalbard and Jan Mayen (+47)",
    phone: "47",
  },
  {
    code: "SK",
    label: "Slovakia (+421)",
    phone: "421",
  },
  {
    code: "SL",
    label: "Sierra Leone (+232)",
    phone: "232",
  },
  {
    code: "SM",
    label: "San Marino (+378)",
    phone: "378",
  },
  {
    code: "SN",
    label: "Senegal (+221)",
    phone: "221",
  },
  {
    code: "SO",
    label: "Somalia (+252)",
    phone: "252",
  },
  {
    code: "SR",
    label: "Suriname (+597)",
    phone: "597",
  },
  {
    code: "SS",
    label: "South Sudan (+211)",
    phone: "211",
  },
  {
    code: "ST",
    label: "Sao Tome and Principe (+239)",
    phone: "239",
  },
  {
    code: "SV",
    label: "El Salvador (+503)",
    phone: "503",
  },
  {
    code: "SX",
    label: "Sint Maarten (Dutch part) (+1-721)",
    phone: "1-721",
  },
  {
    code: "SY",
    label: "Syrian Arab Republic (+963)",
    phone: "963",
  },
  {
    code: "SZ",
    label: "Swaziland (+268)",
    phone: "268",
  },
  {
    code: "TC",
    label: "Turks and Caicos Islands (+1-649)",
    phone: "1-649",
  },
  {
    code: "TD",
    label: "Chad (+235)",
    phone: "235",
  },
  {
    code: "TF",
    label: "French Southern Territories (+262)",
    phone: "262",
  },
  {
    code: "TG",
    label: "Togo (+228)",
    phone: "228",
  },
  {
    code: "TH",
    label: "Thailand (+66)",
    phone: "66",
  },
  {
    code: "TJ",
    label: "Tajikistan (+992)",
    phone: "992",
  },
  {
    code: "TK",
    label: "Tokelau (+690)",
    phone: "690",
  },
  {
    code: "TL",
    label: "Timor-Leste (+670)",
    phone: "670",
  },
  {
    code: "TM",
    label: "Turkmenistan (+993)",
    phone: "993",
  },
  {
    code: "TN",
    label: "Tunisia (+216)",
    phone: "216",
  },
  {
    code: "TO",
    label: "Tonga (+676)",
    phone: "676",
  },
  {
    code: "TR",
    label: "Turkey (+90)",
    phone: "90",
  },
  {
    code: "TT",
    label: "Trinidad and Tobago (+1-868)",
    phone: "1-868",
  },
  {
    code: "TV",
    label: "Tuvalu (+688)",
    phone: "688",
  },
  {
    code: "TW",
    label: "Taiwan, Republic of China (+886)",
    phone: "886",
  },
  {
    code: "TZ",
    label: "United Republic of Tanzania (+255)",
    phone: "255",
  },
  {
    code: "UA",
    label: "Ukraine (+880)",
    phone: "380",
  },
  {
    code: "UG",
    label: "Uganda (+256)",
    phone: "256",
  },
  {
    code: "US",
    label: "United States (+1)",
    phone: "1",
    suggested: true,
  },
  {
    code: "UY",
    label: "Uruguay (+598)",
    phone: "598",
  },
  {
    code: "UZ",
    label: "Uzbekistan (+998)",
    phone: "998",
  },
  {
    code: "VA",
    label: "Holy See (Vatican City State) (+379)",
    phone: "379",
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines (+1-784)",
    phone: "1-784",
  },
  {
    code: "VE",
    label: "Venezuela (+58)",
    phone: "58",
  },
  {
    code: "VG",
    label: "British Virgin Islands (+1-284)",
    phone: "1-284",
  },
  {
    code: "VI",
    label: "US Virgin Islands (+1-340)",
    phone: "1-340",
  },
  {
    code: "VN",
    label: "Vietnam (+84)",
    phone: "84",
  },
  {
    code: "VU",
    label: "Vanuatu (+678)",
    phone: "678",
  },
  {
    code: "WF",
    label: "Wallis and Futuna (+681)",
    phone: "681",
  },
  {
    code: "WS",
    label: "Samoa (+685)",
    phone: "685",
  },
  {
    code: "XK",
    label: "Kosovo (+383)",
    phone: "383",
  },
  {
    code: "YE",
    label: "Yemen (+967)",
    phone: "967",
  },
  {
    code: "YT",
    label: "Mayotte (+262)",
    phone: "262",
  },
  {
    code: "ZA",
    label: "South Africa (+27)",
    phone: "27",
  },
  {
    code: "ZM",
    label: "Zambia (+260)",
    phone: "260",
  },
  {
    code: "ZW",
    label: "Zimbabwe (+263)",
    phone: "263",
  },
];

export default countries;
